import type { TourStepData } from './types';

export const referralDashboardTourSteps: TourStepData[] = [
  {
    target: '[data-tour="referral-dashboard-header"]',
    title: 'Referral Network',
    content:
      'Le Referral Network (Reseau de parrainage) pilote les ambassadeurs, les filleuls et le systeme de recompenses avec detection anti-fraude.',
    placement: 'bottom',
    glossaryTerm: 'referral-network',
  },
  {
    target: '.grid.grid-cols-1.sm\\:grid-cols-2.lg\\:grid-cols-4',
    title: 'KPIs Parrainage',
    content:
      'Total des sponsors, filleuls valides, tokens distribues et pentagones completes — les metriques cles du reseau.',
    placement: 'bottom',
  },
  {
    target: '.fc-card',
    title: 'Top Sponsors',
    content:
      'Classement des meilleurs ambassadeurs par tokens gagnes et filleuls convertis.',
    placement: 'top',
  },
];
